/************************ // @@@ START COPYRIGHT @@@ // AVI SOLAR ENERGY
CONFIDENTIAL: NEED TO KNOW ONLY // Copyright 2018 - 2019 // Avi Solar Energy Pvt Ltd. // Protected as an unpublished
work. // The computer program listings, specifications and documentation // herein are the property of Avi Solar Energy
Pvt Ltd., or a third party supplier // and shall not be reproduced, copied, disclosed, or used in whole or in part for
// any reason without the prior express written permission of Avi Solar Energy Pvt Ltd. // @@@ END COPYRIGHT @@@ // +++
Code modified on 2019/02/25 ************************/ <template>
  <v-container grid-list-md>
    <v-layout row wrap>
      <v-flex xs12>
        <div class="text-xs-left caption pb-4">
          <p>average : sum of all averages the irradiance of every hour</p>
          <p>
            active_passive : calculating the irradiance from primary wms source and getting the missing packets data
            from secondary wms
          </p>
          <p>count_poa : sum(irradiance) / total number of packets received</p>
        </div>
      </v-flex>
      <v-flex xs12>
        <div class="text-xs-center title pb-4">PoA CONFIGURATION</div>
      </v-flex>
      <v-flex xs12>
        <form>
          <v-layout row wrap>
            <v-flex xs12>
              <div class="subheading">Select Calculation Method</div>
            </v-flex>
            <v-flex xs12 sm6>
              <v-select v-model="calculationModel" :items="calculation" label="Calculation Method" outline></v-select>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field label="Configured Calculation Model" v-model="calculationModel" :value="calculationModel"
                outlined></v-text-field>
           </v-flex>


            <v-flex xs12>
              <div class="subheading">Select Primary WMS</div>
            </v-flex>
            <v-flex xs12 sm4>
              <v-select v-model="primaryBlock" :items="blockList" label="PRIMARY BLOCK" return-object outline>
              </v-select>
            </v-flex>
            <v-flex xs12 sm4>
              <v-select v-model="primaryWs" :items="primaryWsList" label="PRIMARY WS" return-object outline></v-select>
            </v-flex>
              <v-text-field label="Configured Primary WMS" :value="`${configPrimaryBlock} - ${configPrimary['name']}`"
                outlined></v-text-field>
            
            <v-flex xs12>
              <div class="subheading">Select Secondary WMS</div>
            </v-flex>
            <v-flex xs12 sm4>
              <v-select v-model="secondaryBlock" :items="blockList" label="SECONDARY BLOCK" return-object outline>
              </v-select>
            </v-flex>
            <v-flex xs12 sm4>
              <v-select v-model="secondaryWs" :items="secondaryWsList" label="SECONDARY WS" return-object outline>
              </v-select>
            </v-flex>
              <v-text-field label="Configured Secondary WMS"
                :value="`${configSecondaryBlock} - ${configSecondary['name']}`" outlined></v-text-field>
          </v-layout>
          <v-btn color="success" @click.prevent="submit">submit</v-btn>
        </form>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import {
    mapMutations,
    mapGetters
  } from "vuex";
  import Vue from "vue";
  import VeeValidate from "vee-validate";
  import PoaConfigApi from "@/services/PoaConfig";
  Vue.use(VeeValidate);
  export default {
    $_veeValidate: {
      validator: "new"
    },
    data: () => ({
      wsData: [],
      blockList: [],
      primaryBlock: null,
      secondaryBlock: null,
      primaryWs: null,
      secondaryWs: null,
      primaryWsList: [],
      secondaryWsList: [],
      list: [],
      wsList: [],
      name: "",
      email: "",
      select: null,
      plant: null,
      plant_list: [],
      blockId: null,
      wsId: null,
      updatedBy: "",
      calculationModel: null,
      calculation: ["average", "active_passive", "count_poa"],
      checkbox: null,
      componentKey: 0,
      configPrimary: {},
      configSecondary: {},
      configPrimaryBlock: "",
      configSecondaryBlock: "",
      isSecondary: false,
      isPrimary: false
    }),

    mounted() {
      this.$validator.localize("en", this.dictionary);
      this.plant_list = this.getPlantList.map(el => el.name);
      if (!this.getSelectedPlantId) {
        this.plant = this.plant_list[0];
      } else {
        this.plant = this.getActivePlantInfo('plant_name');
      }
      this.getBlockDetails();
      this.getConfiguredDetails();
    },
    methods: {
      ...mapMutations(['SET_SHOW_SNACKBAR', 'SET_SNACKBAR_CONTENT']),
      async getConfiguredDetails() {
        const response = await PoaConfigApi.getConfigDetails(
          this.getSelectedPlantId
        );
        const res = await PoaConfigApi.getWeatherDetails(this.getSelectedPlantId);
        const wsRes = res.data.message;
        const data = response.data.message;

        this.calculationModel = data[0]["calculation_type"];
        this.configPrimary["id"] = data[0]["poa_primary_refid"];
        this.configSecondary["id"] = data[0]["poa_secondar_refid"];

        this.blockList.forEach(el => {
          if (this.configPrimary["id"].split("-")[0] == el.value)
            this.configPrimaryBlock = el.text;
          if (this.configSecondary["id"].split("-")[0] == el.value)
            this.configSecondaryBlock = el.text;
        });

        wsRes.forEach(el => {
          if (this.configPrimary["id"] === el.modifiedId)
            this.configPrimary["name"] = el.text;
          if (this.configSecondary["id"] === el.modifiedId)
            this.configSecondary["name"] = el.text;
        });
        this.componentKey += 1;
      },
      async getBlockDetails() {
        const blockRes = await PoaConfigApi.getWsBlock(
          this.getSelectedPlantId
        );
        this.blockList = blockRes.data.message.map(({
          id,
          name
        }) => ({
          text: name,
          value: id
        }));
        this.primaryBlock = this.blockList[0];
        this.secondaryBlock = this.blockList[0];
      },
      async getPrimaryWsDetails(id) {
        const response = await PoaConfigApi.getWsDetails(
          this.getSelectedPlantId,
          id
        );
        this.primaryWs = response.data.message[0];
        this.primaryWsList = response.data.message;
        this.isPrimary = false;
      },
      async getSecondaryWsDetails(id) {
        const response = await PoaConfigApi.getWsDetails(
          this.getSelectedPlantId,
          id
        );
        this.secondaryWs = response.data.message[0];
        this.secondaryWsList = response.data.message;
        this.isSecondary = false;
      },
      async submit() {
        let isValid = await this.$validator.validateAll();
        if (isValid) {
          let param = {
            plantId: this.getSelectedPlantId,
            cal: this.calculationModel,
            primary: this.isPrimary ?
              this.primaryWs["modifiedId"] :
              this.configPrimary["id"],
            secondary: this.isSecondary ?
              this.secondaryWs["modifiedId"] :
              this.configSecondary["id"],
            updatedBy: this.updatedBy
          };
          let response = await PoaConfigApi.configPoa(param);
          if (response.status === 200) {
            let payload = {
              icon: 'success',
              message: "Configuration Updated"
            }
            this.SET_SNACKBAR_CONTENT(payload)
            this.SET_SHOW_SNACKBAR(true)
          } else {
            let payload = {
              icon: 'error',
              message: "Configuration Failed"
            }
            this.SET_SNACKBAR_CONTENT(payload)
            this.SET_SHOW_SNACKBAR(true)
          }
          this.isPrimary = false;
          this.isSecondary = false;
          this.getConfiguredDetails();
          this.componentKey += 1;
        }
      },
      clear() {
        this.plant = null;
        this.blockId = null;
        this.wsId = null;
        this.updatedBy = null;
        this.$validator.reset();
      }
    },
    watch: {
      primaryWs() {
        this.isPrimary = true;
      },
      secondaryWs() {
        this.isSecondary = true;
      },
      primaryBlock() {
        this.getPrimaryWsDetails(this.primaryBlock.value);
      },
      secondaryBlock() {
        this.getSecondaryWsDetails(this.secondaryBlock.value);
      },
      getSelectedPlantId() {
        this.getConfiguredDetails();
        this.getBlockDetails();
      }
    },
    computed: {
      ...mapGetters(["getPlantList", "getSelectedPlantId", "getActivePlantInfo"]),
      isWs() {
        return !(
          this.deviceType !== null && this.deviceType.toLowerCase() === "ws"
        );
      },
      codeList() {
        if (this.deviceType === null) {
          return [];
        }
        let list = this.alertCodeList[this.deviceType.toLowerCase()];
        if (list === undefined) {
          return [];
        }
        return list;
      }
    }
  };
</script>